import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ArrowIcon from '../assets/SVG/icons/gradient-arrow-down.svg';
import config from '../config';
import '../styles/covidresultgradient.css';

export default function CovidResultGradient({threshold, probability, isCovid, questionnaire, isTransparent, children}) {
    const [pos, setPos] = useState(-1000);
    const isASymp = questionnaire ? questionnaire?.cough === "False" &&  questionnaire?.headache === "False" &&  questionnaire?.weakness === "False" &&  questionnaire?.sore_throat === "False" : true;
    const description = isASymp ? config.description[0] : config.description[1];

    const getArrowPos = () => {
        if(threshold) {
            const _probability = parseFloat(probability.toFixed(2));
            if(_probability < threshold) {
                let high = parseFloat((threshold - 0.01).toFixed(2));
                let low = parseFloat((high - 0.09).toFixed(2));
                let pos = 35;
                for(let i=0; i<5; i++) {
                    if(_probability >= low && _probability <= high) {
                        return pos
                    }
                    high = parseFloat((low - 0.01).toFixed(2));
                    low = parseFloat((high - 0.09).toFixed(2));
                    pos -= 5;
                }
                return pos;
            } else {
                let low = threshold;
                let high = parseFloat((low + 0.09).toFixed(2));
                let pos = 65;
                for(let i=0; i<5; i++) {
                    if(_probability >= low && _probability <= high) {
                        return pos
                    }
                    low = parseFloat((high + 0.01).toFixed(2));
                    high = parseFloat((low + 0.09).toFixed(2));
                    pos += 5;
                }
                return pos;
            }
        } else {
            return isCovid ? 75 : 25;
        }
    }

    useEffect(() => {
        setPos(getArrowPos());
    }, [])

    return (
        <div className='covd-gradient' data-testid="covd-gradient">
            <div className='gradient-container' id='covd-gradient'>
                <img src={ArrowIcon} alt="err" style={{ left: `${pos}%` }} className='gradient-arrow'/>
                <div className='test-gradient'>
                    <p className="text-bold font-size-18 text-black">Lower Risk</p>
                    <p className="text-bold font-size-18 text-black">Higher Risk</p>
                </div>
            </div>
            {children}
            <>
                {
                    pos > 50 ? <p className='text-red' data-testid="covd-gradient-higher">
                        You are at higher risk of having COVID-19. <br />The eye scan detected changes that may be associated with COVID-19.
                    </p> :
                    <p className='text-green' data-testid="covd-gradient-lower">
                        You are at lower risk of having COVID-19. <br />The eye scan did not detect changes that may be associated with COVID-19.
                    </p>
                }

                <p className="text-left result-description">
                    {
                        description.map((item, index) => {
                            if(item.type == "link") {
                                return <p key={index}>
                                    {
                                        item.data.map((des, i) => (
                                            des.link ? <a href={des.link} target='_blank'>{des.text}</a> : des.text
                                        ))
                                    }
                                </p>
                            }
                            if(item.type == "list") {
                                return <ul key={index}>
                                {
                                    item.data.map((listItem, k) =>{
                                        if(listItem.type == "link") {
                                            return <li key={index}>
                                                {
                                                    listItem.data.map((des, i) => (
                                                        des.link ? <a href={des.link} target='_blank'>{des.text}</a> : des.text
                                                    ))
                                                }
                                            </li>
                                        }
                                        if(listItem.type == "text") {
                                            return <li>{listItem.data}</li>
                                        }
                                    })
                                }
                                </ul>
                            }
                            if(item.type == "text") {
                                return <p>{item.data}</p>
                            }
                        })
                    }
                </p>                
            </>
                    
            {config.region !== "SA" && <div className="interpretation-link mt-5">
                    {pos > 50 ? <Link to='/positiveresult' className='text-white' data-testid="positiveresult-link">Interpretation of Results</Link>
                        : <Link to='/negativeresult' className='text-white' data-testid="negativeresult-link">Interpretation of Results</Link>}
            </div>}
        </div>
        
    )
}
